import { memo } from "react";
import { LayoutGrid } from "lucide-react";
import { fileUrl } from "@/lib/api";

const Thumb = memo(({ page, active, count, onClick }) => (
  <button onClick={onClick} data-testid={`page-thumb-${page.index}`} className="group w-full text-left">
    <div className={`relative overflow-hidden rounded bg-white ring-2 transition-[box-shadow] ${active ? "ring-[#3D3DF0]" : "ring-transparent group-hover:ring-[#2E2E2E]"}`} style={{ aspectRatio: `${page.width}/${page.height}` }}>
      <img src={fileUrl(page.thumb)} alt={`Page ${page.index}`} loading="lazy" className="h-full w-full object-cover" />
      {count > 0 && <span className="absolute right-1 top-1 rounded bg-[#A62B8A] px-1.5 font-mono text-[10px]">{count}</span>}
    </div>
    <p className={`mt-1 font-mono text-[11px] ${active ? "text-[#0F172A]" : "text-[#64748B]"}`}>{String(page.index).padStart(2, "0")}</p>
  </button>
));

export const PageThumbs = ({ pages, current, layers, onPick, onOrganize }) => (
  <aside className="hidden w-[200px] shrink-0 overflow-y-auto m-3 mr-0 rounded-3xl neu-inset p-4 thin-scroll md:block" data-testid="page-thumbnails">
    <div className="mb-3 flex items-center justify-between"><p className="font-mono text-[10px] uppercase tracking-widest text-[#64748B]">Pages · {pages.length}</p><button onClick={onOrganize} className="neu-btn flex items-center gap-1 rounded-full px-2.5 py-1 text-[10px] font-bold text-[#3D3DF0]" data-testid="organize-pages-btn"><LayoutGrid className="h-3 w-3" />Organize</button></div>
    <div className="space-y-4">
      {pages.map((p) => <Thumb key={p.index} page={p} active={p.index === current} count={(layers[p.index] || []).length} onClick={() => onPick(p.index)} />)}
    </div>
  </aside>
);
